import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { H2, H3 } from 'components/basic/Typography';

import s from './NumberedItems.module.scss';

interface Props {
  items: string[];
  className?: string;
}

const NumberedItems: FC<Props> = ({ items, className }) => {
  const els = items.map((item, i) => {
    return (
      <div className={cn(s.item)} key={item}>
        <H2 className={s.number} Tag="span">
          {i + 1}
        </H2>
        <H3 Tag="span">{item}</H3>
      </div>
    );
  });

  return <div className={cn(s.wrapper, className, 'grid')}>{els}</div>;
};

export default NumberedItems;
